module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Low Battery","short_name":"Low Battery","start_url":"/","background_color":"#000000","theme_color":"#000000","display":"standalone","icon":"static/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"293d941e6261bf26a60af9372d8635c3"},
    },{
      plugin: require('../node_modules/gatsby-plugin-prismic-previews/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"lowbattery","accessToken":"MC5hWDdNNWhJQUFDWUF2WDM3.d--_vWvvv71677-977-9Fu-_vTzvv70877-9YgXvv73vv73vv73vv71L77-977-9O--_vRtgK--_vU3vv71d77-9"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
